import React from "react";

import Button from '@material-ui/core/Button';
import DeleteIcon from '@material-ui/icons/Delete';

export const DeleteButton = (props) => {
	return <Button color="secondary" startIcon={<DeleteIcon />} {...props}>Cancella</Button>;
}
